import * as actionTypes from "../actionTypes";
import Messages from "../../../helper/messages";
import ReactHtmlParser from "react-html-parser";
import { store } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
import * as ImmersionGQL from "../../../gql";

//set loader
const setLoading = (loading: boolean) => ({
	type: actionTypes.SET_LOADING,
	payload: loading
});

// Add role Success
const addRoleSuccess = (item: any) => ({
	type: actionTypes.ADD_ROLE_SUCCESS,
	payload: item,
});

// Update role Success
const updateRoleSuccess = (item: any) => ({
	type: actionTypes.UPDATE_ROLE_SUCCESS,
	payload: item,
});

// Change role status Success
const changeRoleStatusSuccess = (item: any) => ({
	type: actionTypes.CHANGE_ROLE_STATUS_SUCCESS,
	payload: item,
});

//Get all admin roles
const getRoleList = (items: any) => ({
	type: actionTypes.GET_ALL_ROLES,
	payload: items
});

//Get role by id
const getRoleBYId = (items: any) => ({
	type: actionTypes.GET_ROLE_BY_ID,
	payload: items
});


// fail notification
const notificationFail = (err: any, errormessage: any) => {
	let msg = Messages.NOTIFICATIONS.ERROR.someThingWrong
	if (errormessage) {
		msg = errormessage
	}
	if (err.graphQLErrors && err.graphQLErrors.length > 0) {
		msg = err.graphQLErrors[0].message;
	} else if (err.message) {
		msg = err.message;
	}
	store.addNotification({
		title: "Error!",
		message: <p>{ReactHtmlParser(msg)}</p>,
		type: "danger",
		insert: "bottom",
		container: "bottom-center",
		animationIn: ["animate__animated", "animate__fadeIn"],
		animationOut: ["animate__animated", "animate__fadeOut"],
		dismiss: {
			duration: 3000,
			onScreen: true
		}
	})
	return {
		type: actionTypes.ADD_NEW_NOTIFICATION_FAIL,
		state: msg
	}
}

// create a role
export const createRole = (client: any, req: any) => {
	return (dispatch: any) => {
		const variables = { ...req };
		dispatch(setLoading(true));
		client.mutate({
			mutation: ImmersionGQL.mutationAddRole,
			fetchPolicy: "no-cache",
			variables
		}).then((res: any) => {
			if (res.data.addRole.status === "true") {
				dispatch(addRoleSuccess(res.data.addRole));
				const request = {
					customer_name: req.schema
				}
				dispatch(getAdminRoles(client, request))
			} else {
				dispatch(notificationFail({}, res.data.addRole.message))
			}
			dispatch(setLoading(false));
		}).catch(() => {
			// handle error
			dispatch(setLoading(false));
		})
	}
};

//Get all admin role
export const getAdminRoles = (client: any, req: any) => {
	return (dispatch: any) => {
		dispatch(setLoading(true));
		client.query({
			query: ImmersionGQL.queryGetRoleList,
			fetchPolicy: "no-cache",
			variables: { customer_name: req.customer_name }
		})
		.then((res: any) => {
			if (res.data.getRoleList) {
				dispatch(getRoleList(res.data.getRoleList));
			} else {
				dispatch(notificationFail({}, res.data.getRoleList.message))
			}
			dispatch(setLoading(false));
		}).catch(() => {

		})
	}
};

// delete a role
export const deleteRole = (client: any, req: any) => {
	return (dispatch: any) => {
		const variables = { ...req };
		dispatch(setLoading(true));
		client.mutate({
			mutation: ImmersionGQL.mutationDeleteRole,
			fetchPolicy: "no-cache",
			variables
		}).then((res: any) => {
			if (res.data.deleteRole.status === "true") {
				const request = {
					customer_name: req.schema
				}
				dispatch(getAdminRoles(client, request))
			} else {
				dispatch(notificationFail({}, res.data.deleteRole.message))
			}
			dispatch(setLoading(false));
		}).catch(() => {
			// handle error
			dispatch(setLoading(false));
		})
	}
};

//get role by id
export const getRole = (client: any, req: any) => {
	return (dispatch: any) => {
		const variables = { ...req };
		dispatch(setLoading(true));
		client.query({
			query: ImmersionGQL.queryGetRole,
			fetchPolicy: "no-cache",
			variables: variables
		})
		.then((response: any) => {
			if (response.data.getRole.status === "true") {
				if (response.data.getRole.data.length > 0) {
					const result = response.data.getRole.data[0];
					let accesspages = {}
					result.accesspages.forEach((val: any) => {
						accesspages = Object.assign(accesspages, { [val.access_name]: val.access_value })
					})
					const roledata = {
						role_id: result.role_id,
						role_name: result.role_name,
						active: result.active,
						role_alias: !!result.role_alias ? result.role_alias : "",
						role_desc: !!result.role_description ? result.role_description : "",
						accesspages: accesspages
					}
					dispatch(getRoleBYId(roledata))
				}
			} else {
				dispatch(notificationFail({}, response.data.getRole.message))
			}
			dispatch(setLoading(false));
		}).catch(() => {

		})
	}
};
// update a role
export const updateRole = (client: any, req: any) => {
	return (dispatch: any) => {
		const variables = { ...req };
		dispatch(setLoading(true));
		client.mutate({
			mutation: ImmersionGQL.mutationEditRole,
			fetchPolicy: "no-cache",
			variables
		}).then((res: any) => {
			if (res.data.editRole.status === "true") {
				dispatch(updateRoleSuccess(res.data.editRole));
				const request = { customer_name: req.schema }
				dispatch(getAdminRoles(client, request))
			} else {
				dispatch(notificationFail({}, res.data.editRole.message))
			}
			dispatch(setLoading(false));
		}).catch(() => {
			// handle error
			dispatch(setLoading(false));
		})
	}
};

// Change role status
export const changeRoleStatus = (client: any, req: any) => {
	return (dispatch: any) => {
		const variables = { ...req };
		dispatch(setLoading(true));
		client.mutate({
			mutation: ImmersionGQL.mutationChangeRoleStatus,
			fetchPolicy: "no-cache",
			variables
		}).then((res: any) => {
			if (res.data.changeRoleStatus.status === "true") {
				dispatch(changeRoleStatusSuccess(res.data.changeRoleStatus));
				const request = { customer_name: req.schema }
				dispatch(getAdminRoles(client, request))
			} else {
				dispatch(notificationFail({}, req.data.toggleActiveRole.message))
			}
			dispatch(setLoading(false));
		}).catch(() => {
			// handle error
			dispatch(setLoading(false));
		})
	}
};




